import { render, staticRenderFns } from "./gflink.vue?vue&type=template&id=3564b033&scoped=true"
import script from "./gflink.vue?vue&type=script&lang=js"
export * from "./gflink.vue?vue&type=script&lang=js"
import style0 from "./gflink.vue?vue&type=style&index=0&id=3564b033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564b033",
  null
  
)

export default component.exports